import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectableCategory } from '../../../models/categories/category.models';

@Component({
    selector: 'category-tree-root',
    template: require('./category.tree.root.html')
})
export class CategoryTreeRoot {
    private _categories: Array<SelectableCategory>;

    @Input()
    set categories(categories: Array<SelectableCategory>) {
        categories.forEach((category: SelectableCategory) => { this.setShowCategory(category); });

        this._categories = categories;
    }

    private setShowCategory(category: SelectableCategory) {
        category.children.forEach((c: SelectableCategory) => { this.setShowCategory(c); });

        category.show = true;
    }

    get categories() {
        return this._categories;
    }

    @Output() selectedChanged = new EventEmitter<any>();

    onSelectedChanged() {
        this.selectedChanged.emit();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/category.tree.view/category.tree.root.ts